import { Quantities } from "@/types/quantities";
import {Product, ProductGroup} from "@/types/product";

//* This function is used to calculate the estimated delivery time in weeks (from x to y weeks)
export const getDeliveryTime = (
    products: Product[],
    quantities: Quantities
) => {
    let maxFrom = 0;
    let maxTo = 0;

    for (const key in quantities) {
        const product = products.find((product) => product.sku === key);

        if (!product || quantities[key] === 0) {
            continue;
        }

        if (product.deliveryInWeeksFrom > maxFrom) {
            maxFrom = product.deliveryInWeeksFrom;
        }

        if (product.deliveryInWeeksTo > maxTo) {
            maxTo = product.deliveryInWeeksTo;
        }
    }
    return [maxFrom, maxTo];
};

export const checkAllowedPalletShipping = (quantities: Quantities) => {
    for (const key in quantities) {
        if (quantities["C2G"] >= 224 || quantities["M2G"] >= 560) {
            return true;
        }
    }
    return false;
};

const getLocaleFromCurrency = (currency: string): string => {
    switch (currency) {
        case "CHF":
            return "de-CH";
        case "USD":
            return "en-US";
        case "NOK":
            return "nb-NO";
        case "GBP":
            return "en-GB";
        default:
            return "de-DE";
    }
};

export const toCurrency = (value: number, currency: string): string => {
    const formatter = new Intl.NumberFormat(getLocaleFromCurrency(currency), {
        style: "currency",
        currency: currency,
    });

    return formatter.format(value);
};

export const toNumber = (value: number): string => {
    const formatter = new Intl.NumberFormat("de-DE");

    return formatter.format(value);
};

export const getNetFromGross = (gross: number, taxRate: number): number => {
    return gross / (1 + taxRate / 100);
};

export const getTotalQuantity = (quantities: Quantities): number => {
    let totalQuantity = 0;

    for (const key in quantities) {
        totalQuantity += quantities[key];
    }

    return totalQuantity;
};

export const getTotalGroupQuantity = (quantities: Quantities, productGroup: ProductGroup, products: Product[]): number => {
    let totalQuantity = 0;

    for (const key in quantities) {
        const product = products.find((product) => product.sku === key);
        if (product.group === productGroup.id) {
            totalQuantity += quantities[key];
        }
    }

    return totalQuantity;
}

export const didMetMinimumForProductGroup = (quantities: Quantities, productGroups: ProductGroup[], products: Product[]): boolean => {

    for (const productGroup of productGroups) {
        if (productGroup.minQuantity > 0) {
            const groupQuantity = getTotalGroupQuantity(
                quantities,
                productGroup,
                products
            );

            if (groupQuantity > 0 &&groupQuantity < productGroup.minQuantity) {
                return false;
            }
        }
    }

    return true;
}

export const getTotalWeight = (
    products: Product[],
    quantities: Quantities
): number => {
    let totalWeight = 0;

    for (const key in quantities) {
        const product = products.find((product) => product.sku === key);

        if (product) {
            totalWeight += product.weight * quantities[key];
        }
    }

    return Math.round(totalWeight / 1000);
};
